import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaFacebookF, FaInstagram, FaWhatsapp } from 'react-icons/fa';
import { FaTiktok } from 'react-icons/fa6';
import contactUsBg from '../assets/River/17.jpeg';

const ContactUs2 = () => {
    const { t } = useTranslation('contact2');

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        contactNumber: '',
        message: '',
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setSuccessMessage('');
        setErrorMessage('');

        const phoneNumber = '94777382466';
        const text = `${t('whatsappSubject')}
${t('whatsappName')}: ${formData.name}
${t('whatsappEmail')}: ${formData.email}
${t('whatsappContactNumber')}: ${formData.contactNumber}
${t('whatsappMessage')}: ${formData.message}`;

        const formattedMessage = encodeURIComponent(text);
        const whatsappUrl = `https://wa.me/${phoneNumber}?text=${formattedMessage}`;

        try {
            window.open(whatsappUrl, '_blank');
            setTimeout(() => {
                setIsSubmitting(false);
                setSuccessMessage(t('successMessage'));
                setFormData({ name: '', email: '', contactNumber: '', message: '' });
            }, 1000);
        } catch (error) {
            setIsSubmitting(false);
            setErrorMessage(t('errorMessage'));
        }
    };

    return (
        <div className="min-h-screen bg-gray-100">
            {/* Hero Section */}
            <div className="relative w-full h-[400px] md:h-[500px] font-copperplate">
                <img
                    src={contactUsBg}
                    alt="Contact Us"
                    className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-black bg-opacity-50 flex flex-col items-center justify-center">

                    <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white">
                        {t('heroTitle')}
                    </h1>
                    <h2 className="text-xl md:text-2xl lg:text-3xl text-[#96BA33] mt-2 font-lato">
                        {t('heroSubtitle')}
                    </h2>
                </div>
            </div>

            {/* Contact Information Section */}
            <section className="bg-[#1F1F1F] py-12">
                <div className="container mx-auto flex flex-col items-center gap-8 px-4 lg:flex-row lg:items-start">
                    {/* Left Column - Contact Info */}
                    <div className="flex flex-1 flex-col items-center space-y-6 text-center lg:items-start lg:text-left">
                        <div className="space-y-6">
                            <h2 className="font-lato text-[20px] font-light tracking-[5%] text-white lg:text-[20px]">
                                {t('sectionTitle')}
                            </h2>
                            <h1 className="text-[22px] font-semibold leading-relaxed tracking-[5%] text-white lg:max-w-2xl lg:text-[40px]">
                                {t('sectionSubtitle')}
                            </h1>
                            <p className="font-lato text-[12px] font-normal leading-relaxed tracking-[5%] text-white lg:text-[18px]">
                                {t('sectionDescription')}
                            </p>
                        </div>

                        <div className="my-6 w-16 border-t-2 border-[#8E8E8E] lg:hidden"></div>

                        <div className="flex w-full flex-col gap-8 lg:flex-row lg:gap-6">
                            {/* Left Sub-Column */}
                            <div className="flex w-full flex-col gap-8">
                                <div className="space-y-4">
                                    <h3 className="font-lato text-[18px] font-semibold tracking-[5%] text-white lg:text-[25px]">
                                        {t('callUs')}
                                    </h3>
                                    <p className="font-lato text-[18px] font-semibold tracking-[5%] text-white lg:text-[20px]">
                                        +94 34 227 8070
                                    </p>
                                    <p className="font-lato text-[18px] font-semibold tracking-[5%] text-white lg:text-[20px]">
                                        +94 34 227 7048
                                    </p>
                                    <p className="font-lato text-[18px] font-semibold tracking-[5%] text-white lg:text-[20px]">
                                        +94 77 738 2466
                                    </p>
                                </div>
                                <div className="space-y-4">
                                    <h3 className="font-lato text-[18px] font-semibold tracking-[5%] text-white lg:text-[25px]">
                                        {t('emailTitle')}
                                    </h3>
                                    <p className="font-lato text-[18px] font-semibold tracking-[5%] text-white lg:text-[20px]">
                                        muthuabr@yahoo.com
                                    </p>
                                </div>
                            </div>

                            {/* Right Sub-Column */}
                            <div className="flex w-full flex-col gap-8">
                                <div className="space-y-4">
                                    <h3 className="font-lato text-[18px] font-semibold tracking-[5%] text-white lg:text-[25px]">
                                        {t('ourLocation')}
                                    </h3>
                                    <p className="mx-auto max-w-64 font-lato text-[18px] font-medium leading-relaxed tracking-[5%] text-white lg:mx-0 lg:max-w-none lg:text-[18px]">
                                        {t('locationAddress')}
                                    </p>
                                </div>
                                <div className="space-y-4">
                                    <h3 className="font-lato text-[18px] font-semibold tracking-[5%] text-white lg:text-[25px]">
                                        {t('socialNetwork')}
                                    </h3>
                                    <div className="flex justify-center space-x-4 lg:justify-start">
                                        <a
                                            href="https://web.facebook.com/profile.php?id=61587185531592"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            aria-label={t('ariaFacebook')}
                                        >
                                            <FaFacebookF className="h-6 w-6 text-[#96BA33] hover:text-white transition-colors" />
                                        </a>
                                        <a
                                            href="https://www.instagram.com/muthumuni_ayurveda_resorts/?hl=en"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            aria-label={t('ariaInstagram')}
                                        >
                                            <FaInstagram className="h-6 w-6 text-[#96BA33] hover:text-white transition-colors" />
                                        </a>
                                        <a
                                            href="https://wa.me/+94777382466"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            aria-label={t('ariaWhatsApp')}
                                        >
                                            <FaWhatsapp className="h-6 w-6 text-[#96BA33] hover:text-white transition-colors" />
                                        </a>
                                        <a
                                            href="https://www.tiktok.com/@muthumuni_ayurveda?_r=1&_t=ZS-93hYxrairkP"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            aria-label={t('ariaTikTok')}
                                        >
                                            <FaTiktok className="h-6 w-6 text-[#96BA33] hover:text-white transition-colors" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Right Column - Contact Form */}
                    <div className="w-full max-w-md flex-1 rounded-2xl border border-[#212121] bg-[#212121] p-6 lg:max-w-none">
                        <div className="space-y-4">
                            <h2 className="mt-4 font-lato text-[20px] font-semibold tracking-[5%] text-white lg:text-[30px]">
                                {t('getInTouch')}
                            </h2>
                            <p className="font-lato text-[12px] font-semibold leading-relaxed tracking-[5%] text-white lg:text-[18px]">
                                {t('getInTouchDescription')}
                            </p>
                        </div>

                        <form className="mt-6 space-y-6" onSubmit={handleSubmit}>
                            <div>
                                <label className="block font-lato text-[16px] font-semibold tracking-[5%] text-white">
                                    {t('nameLabel')}
                                </label>
                                <input
                                    type="text"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    className="w-full border-b border-white bg-transparent py-2 font-lato text-[16px] font-normal text-white outline-none"
                                    required
                                />
                            </div>
                            <div>
                                <label className="block font-lato text-[16px] font-semibold tracking-[5%] text-white">
                                    {t('emailLabel')}
                                </label>
                                <input
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    className="w-full border-b border-white bg-transparent py-2 font-lato text-[16px] font-normal text-white outline-none"
                                    required
                                />
                            </div>
                            <div>
                                <label className="block font-lato text-[16px] font-semibold tracking-[5%] text-white">
                                    {t('contactNumberLabel')}
                                </label>
                                <input
                                    type="tel"
                                    name="contactNumber"
                                    value={formData.contactNumber}
                                    onChange={handleChange}
                                    className="w-full border-b border-white bg-transparent py-2 font-lato text-[16px] font-normal text-white outline-none"
                                />
                            </div>
                            <div>
                                <label className="block font-lato text-[16px] font-semibold tracking-[5%] text-white">
                                    {t('messageLabel')}
                                </label>
                                <textarea
                                    name="message"
                                    value={formData.message}
                                    onChange={handleChange}
                                    className="w-full border-b border-white bg-transparent py-2 font-lato text-[16px] font-normal text-white outline-none"
                                    rows={4}
                                    required
                                />
                            </div>

                            {successMessage && (
                                <p className="font-lato text-[14px] text-green-500">
                                    {successMessage}
                                </p>
                            )}
                            {errorMessage && (
                                <p className="font-lato text-[14px] text-red-500">
                                    {errorMessage}
                                </p>
                            )}

                            <button
                                type="submit"
                                disabled={isSubmitting}
                                className={`flex h-[49px] w-[150px] items-center justify-center space-x-2 rounded-full bg-white font-lato text-[12px] font-semibold text-black lg:h-[59px] lg:w-[210px] lg:text-[20px] ${isSubmitting ? 'cursor-not-allowed opacity-50' : ''
                                    }`}
                            >
                                <span>{isSubmitting ? t('sending') : t('sendMessage')}</span>
                                {!isSubmitting && (
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        strokeWidth="1.5"
                                        stroke="currentColor"
                                        className="size-6"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="m4.5 19.5 15-15m0 0H8.25m11.25 0v11.25"
                                        />
                                    </svg>
                                )}
                            </button>
                        </form>
                    </div>
                </div>
            </section>

            {/* Location Map Section */}
            <section className="bg-[#1F1F1F] py-12">
                <div className="container mx-auto px-4">
                    <h2 className="text-3xl md:text-3xl font-semibold text-white text-center mb-8">
                        {t('findUsOnMap')}
                    </h2>
                    <div className="flex justify-center">
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5120.955240139246!2d79.9916305!3d6.444030199999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae22e641e45a72b%3A0x4a6bb906904b0a58!2sMuthumuni%20Ayurveda%20River%20Resort!5e1!3m2!1sen!2slk!4v1768805588758!5m2!1sen!2slk"
                            width="600"
                            height="450"
                            className="w-full rounded-lg border-0"
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            title={t('findUsOnMap')}
                        ></iframe>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ContactUs2;